import { map } from 'lodash'
import React from 'react'

import Select from '../../Select'
import { getCronDays } from '../utils'

const CronDaySelect = (props: any): React.ReactElement => {
  return (
    <Select
      {...props}
      direct
      options={getCronDays()}
      value={map(props.value, (v) => parseInt(v))}
    />
  )
}

export default CronDaySelect
